import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.5 17.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M12.5 22.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M16 21a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M17.5 17.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M22.5 17.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.993 3.883A1 1 0 0 0 21 4v1H11V4l-.007-.117A1 1 0 0 0 9 4v1H6l-.15.005A2 2 0 0 0 4 7v20l.005.15A2 2 0 0 0 6 29h20l.15-.006A2 2 0 0 0 28 27V7l-.006-.15A2 2 0 0 0 26 5h-3V4zM6 13h20v14H6zm3-6H6v4h20V7h-3v1a1 1 0 0 1-1.993.117L21 8V7H11v1a1 1 0 0 1-1.993.117L9 8z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSchedule = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSchedule);
export default Memo;
